<template>
  <div class="aha-masonry" :id="masonryId">
    <slot />
  </div>
</template>

<script>
export const masonryMixin = {
  data() {
    return {
      grid: null,
    }
  },
  methods: {
    resizeMasonryItem(masonryItem) {
      const masonryContent = masonryItem.querySelector('.aha-masonry__content')
      const masonryContentHeight = masonryContent.getBoundingClientRect().height

      const rowHeight = parseInt(window.getComputedStyle(this.grid).getPropertyValue('grid-auto-rows'), 10)
      const gapBetweenMasonryItem = parseInt(window.getComputedStyle(this.grid).getPropertyValue('grid-row-gap'), 10)

      const rowSpan = Math.round(masonryContentHeight / (rowHeight + gapBetweenMasonryItem)) + 1
      masonryItem.style.gridRowEnd = `span ${rowSpan}`
    },
    redrawMasonryById(masonryId) {
      this.grid = document.getElementById(masonryId)

      if (!this.grid) {
        return
      }

      this.masonryItems = this.grid.getElementsByClassName('aha-masonry__item')

      for (let x = 0; x < this.masonryItems.length; x++) {
        this.resizeMasonryItem(this.masonryItems[x])
      }
    },
  },
}

export default {
  mixins: [masonryMixin],
  props: {
    masonryId: {
      type: String,
      required: true,
    },
  },
  mounted() {
    window.onload = this.redrawMasonryById(this.masonryId)
    window.addEventListener('resize', () => this.redrawMasonryById(this.masonryId))
  },
}
</script>

<style lang="scss">
.aha-masonry {
  display: grid;
  grid-gap: 10px;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  grid-auto-rows: 1px;
}

</style>
